import { i18n } from '@/common/utils/i18n'
import i18nVue from '@/i18n/locale'

export const PERSON_TYPE_MAP = {
  person: i18nVue.t('FoodB_CO_mpOD_dQFB'),
  business: i18nVue.t('FoodB_CO_ksMa_ymXB'),
}

export const SIGN_TAX_TYPE_LIST_CO = [
  {
    value: 'CC',
    // label: i18nVue.t('FoodB_Show_Colombia_ID_igRe' /** 身份证 */),
    label: i18nVue.t('FoodB_CO_MlOY_aPvr' /** 身份证 */),
  },
  {
    value: 'CE',
    // label: i18nVue.t('FoodB_Show_Colombia_Aliens_xrvS' /** 外国人居留卡 */),
    label: i18nVue.t('FoodB_CO_jhVR_FWRm' /** 外国人居留卡 */),
  },
  {
    value: 'PPT',
    label: i18nVue.t('FoodB_CO_hxPS_NoXd' /** 临时居留许可证 */),
  },
  {
    value: 'PEP',
    label: i18nVue.t('FoodB_options_pMML_QUyg' /** 外国人特殊居留证 */),
  },
  {
    value: 'Passport',
    label: i18nVue.t('FoodB_CO_yweP_bWhk' /** 护照 */),
  },
  {
    value: 'NIT',
    label: i18nVue.t('FoodB_options_bBhm_incO' /** 唯一税务登记号 */),
  },
]

export const SIGN_TAX_TYPE_LIST_CO_MAP = {
  CC: i18nVue.t('FoodB_CO_MlOY_aPvr' /** 身份证 */),
  CE: i18nVue.t('FoodB_CO_jhVR_FWRm' /** 外国人居留卡 */),
  PPT: i18nVue.t('FoodB_CO_hxPS_NoXd' /** 临时居留许可证 */),
  PEP: i18nVue.t('FoodB_options_pMML_QUyg' /** 外国人特殊居留证 */),
  Passport: i18nVue.t('FoodB_CO_yweP_bWhk' /** 护照 */),
  NIT: i18nVue.t('FoodB_options_bBhm_incO' /** 唯一税务登记号 */),
}

export const SIGN_LEGAL_TYPE_LIST_CO_ENUM = [
  {
    value: 9,
    // label: i18nVue.t('FoodB_Show_Colombia_ID_igRe' /** 身份证 */),
    label: i18nVue.t('FoodB_CO_MlOY_aPvr' /** 身份证 */),
  },
  {
    value: 10,
    // label: i18nVue.t('FoodB_Show_Colombia_Aliens_xrvS' /** 外国人居留卡 */),
    label: i18nVue.t('FoodB_CO_jhVR_FWRm' /** 外国人居留卡 */),
  },
  {
    value: 44,
    label: i18nVue.t('FoodB_CO_hxPS_NoXd' /** 临时居留许可证 */),
  },
  {
    value: 14,
    label: i18nVue.t(
      // 'FoodB_Show_Special_residence_ezfV' /** 外国人特殊居留证 */
      'FoodB_options_pMML_QUyg' /** 外国人特殊居留证 */,
    ),
  },
  {
    value: 43,
    label: i18nVue.t('FoodB_CO_yweP_bWhk' /** 护照 */),
  },
  {
    value: 15,
    label: i18nVue.t('FoodB_options_bBhm_incO' /** 唯一税务登记号 */),
  },
]

export const SIGN_LEGAL_TYPE_LIST_CO_MAP = {
  9: i18nVue.t('FoodB_CO_MlOY_aPvr' /** 身份证 */),
  10: i18nVue.t('FoodB_CO_jhVR_FWRm' /** 外国人居留卡 */),
  44: i18nVue.t('FoodB_CO_hxPS_NoXd' /** 临时居留许可证 */),
  14: i18nVue.t('FoodB_options_pMML_QUyg' /** 外国人特殊居留证 */),
  43: i18nVue.t('FoodB_CO_yweP_bWhk' /** 护照 */),
  15: i18nVue.t('FoodB_options_bBhm_incO' /** 唯一税务登记号 */),
}

export const SHOP_IMEI_HISTORY_STATUS_MAP = {
  1: i18n.gettext('此店领用PAD'),
  2: i18n.gettext('非此店领用PAD'),
  3: i18n.gettext('商户自有设备'),
}
// storeFrontDeliveryType
export const STORE_FRONT_DELIVERY_TYPE_MAP = {
  1: i18nVue.t('FoodB_order_ncPz_yPAH'),
  2: i18nVue.t('FoodB_2_mfKY_fvJg'),
}
export const COMPLETION_STATUS = [
  {
    label: i18nVue.t('FoodC_orderlist_Completed_Xuod' /** 已完成 */),
    value: 1,
  },
  {
    label: i18nVue.t('FoodB_optimization_TjHf_zaEo' /** 未完成 */),
    value: 2,
  },
]

export const COMPLETION_STATUS_MAP = {
  1: i18nVue.t('FoodC_orderlist_Completed_Xuod' /** 已完成 */),
  2: i18nVue.t('FoodB_optimization_TjHf_zaEo' /** 未完成 */),
}

export const STORE_FRONT_OPEN_TASK_MAP = {
  0: i18nVue.t('FoodB_optimization_TjHf_zaEo' /** 未完成 */),
  1: i18nVue.t('FoodC_orderlist_Completed_Xuod' /** 已完成 */),
}

export const WEEK_MAP = {
  1: i18n.gettext('周一'),
  2: i18n.gettext('周二'),
  3: i18n.gettext('周三'),
  4: i18n.gettext('周四'),
  5: i18n.gettext('周五'),
  6: i18n.gettext('周六'),
  7: i18n.gettext('周日'),
}

export const COMMISSION_JSON_PLATFORM_RATE = [
  {
    label: i18n.gettext('平台配送佣金比例'),
    value: 1,
  },
  {
    label: i18n.gettext('自配送佣金比例'),
    value: 2,
  },
]

export const PROGRAM_MAP = {
  1: i18n.gettext('三个月试用期'),
  2: i18n.gettext('无试用期'),
  3: i18n.gettext('免费使用'),
}

export const SCHEME_RULES_MAP = {
  1: {
    mounth: i18n.gettext('试用时间3个月'),
    week: i18n.gettext('押金收取周期5周'),
    money: i18n.gettext('押金$1500'),
  },
  2: {
    mounth: i18n.gettext('试用时间0个月'),
    week: i18n.gettext('押金收取周期5周'),
    money: i18n.gettext('押金$1500'),
  },
  3: {
    mounth: i18n.gettext('试用时间0个月'),
    week: i18n.gettext('押金收取周期0周'),
    money: i18n.gettext('押金$0'),
  },
}

export const ORDER_REMARK_SWITCH_MAP = {
  1: i18nVue.t('FoodC_text_WMkV_qNzN' /** 开启 */),
  2: i18nVue.t('FoodB_UI_RToR_WdHq' /** 关闭 */),
}

export const VERIFICATION_RESULT_MAP = {
  0: i18n.gettext('暂无'),
  1: i18n.gettext('需要'),
  2: i18n.gettext('不需要'),
}

export const VERIFICATION_RESULT = [
  {
    label: i18n.gettext('暂无'),
    value: 0,
  },
  {
    label: i18n.gettext('需要'),
    value: 1,
  },
  {
    label: i18n.gettext('不需要'),
    value: 2,
  },
]

export const PAD_STATUS_MAP = {
  1: i18n.gettext('入库未配置'),
  2: i18n.gettext('入库已配置'),
  3: i18n.gettext('出库未交付'),
  4: i18n.gettext('出库已交付'),
}

export const CARD_HOLDER_TYPE_CO = [
  {
    label: i18nVue.t('FoodB_Show_Colombia_ID_igRe' /** 哥伦比亚-身份证 */),
    value: 9,
  },
  {
    label: i18nVue.t('FoodB_Show_Colombia_Aliens_xrvS' /** 哥伦比亚-外国人居留卡 */),
    value: 10,
  },
  {
    label: i18nVue.t('Others_platform_Tax_documents_jEir' /** 税务证件 */),
    value: 15,
  },
]

export const CARD_HOLDER_TYPE_CO_MAP = {
  9: i18nVue.t('FoodB_Show_Colombia_ID_igRe' /** 哥伦比亚-身份证 */),
  10: i18nVue.t('FoodB_Show_Colombia_Aliens_xrvS' /** 哥伦比亚-外国人居留卡 */),
  15: i18nVue.t('Others_platform_Tax_documents_jEir' /** 税务证件 */),
}

export const SIGN_NEED_PAD_MAP = {
  1: i18nVue.t('FoodB_optimization_Needs_IovK' /** 需要 */),
  0: i18nVue.t('FoodB_field_No_need_hToz' /** 不需要 */),
}

export const TAX_TYPE_MAP = {
  1: i18nVue.t('FoodB_Show_Not_applicable_jXBz' /** 不适用 */),
  2: i18nVue.t('FoodB_Show_Provisional_Tax_xJRc' /** 临时缴税金额 */),
  3: i18nVue.t('FoodB_Show_Final_Tax_XQQi' /** 最终缴税金额 */),
}

export const ACCOUNT_CARD_TYPE_MAP = {
  1: i18nVue.t('FoodB_Show_Current_NJqK' /** 活期 */),
  2: i18nVue.t('FoodB_Show_Savings_uvSS' /** 储蓄 */),
}

export const SIGN_ACCOUNT_TYPE_MAP = {
  1: i18nVue.t('FoodB_accountInfo_NjKP_vPaS' /** 对公 */),
  2: i18nVue.t('FoodB_accountInfo_sstp_wipw' /** 对私 */),
}

export const SIGN_ACCOUNT_TYPE = [
  {
    label: i18nVue.t('FoodB_accountInfo_NjKP_vPaS' /** 对公 */),
    value: 1,
  },
  {
    label: i18nVue.t('FoodB_accountInfo_sstp_wipw' /** 对私 */),
    value: 2,
  },
]

// 违规处罚 统计周期
export const PENALTY_TIME_WINDOW_CONF = [
  {
    label: i18nVue.t('Gattaran_B86_QDHl_huvy' /** 每个自然月 */),
    value: 1,
  },
  {
    label: i18nVue.t('Gattaran_B86_zSoI_miDd' /** 累计 */),
    value: 2,
  },
]

// 违规处罚 处罚类型
export const PENALTY_TYPE_CONF = [
  {
    label: i18nVue.t('Gattaran_B86_YERx_BJAp' /** 加收佣金 */),
    value: 1,
  },
  {
    label: i18nVue.t('Gattaran_B86_yyBF_minr' /** 撤销佣金补贴 */),
    value: 2,
  },
]

// 违规处罚 处罚时长类型
export const PENALTY_DURATION_TYPE_CONF = [
  {
    label: i18nVue.t('Gattaran_B86_uxLG_ApUK' /** 固定时长 */),
    value: 1,
  },
  {
    label: i18nVue.t('Gattaran_B86_UDvE_JOul' /** 按违规时间 */),
    value: 2,
  },
]

function generateNum(startNum, endNum, range, includeLeft, includeEnd) {
  const result = []
  for (let i = startNum; i <= endNum; i = i + range) {
    result.push(i)
  }
  if (!includeLeft) {
    result.splice(0, 1)
  }
  if (!includeEnd) {
    result.splice(-1, 1)
  }
  return result
}

export const SIGN_BONUS_CHANNEL_MAP = {
  1: i18nVue.t('Gattaran_B90_eaoL_NdPq', { name: 'GTR' }),
  2: i18nVue.t('Gattaran_B90_eaoL_NdPq', { name: 'Pro one' }),
  3: i18nVue.t('Gattaran_B90_stGO_Tlng'), // 其他系统发放
}

export const SIGN_YES_NO = [
  { label: i18nVue.t('Gattaran_Project1_UAHJ_vNYg' /** 是 */), value: 1 },
  { label: i18nVue.t('Gattaran_Project1_qUNd_LROh' /** 否 */), value: 0 },
]

// 是否
export const SIGN_YES_NO_MAP = {
  1: i18nVue.t('Gattaran_Project1_UAHJ_vNYg' /** 是 */),
  0: i18nVue.t('Gattaran_Project1_qUNd_LROh' /** 否 */),
}

// 合同类型
export const SIGN_CONTRACT_TYPE_MAP = {
  1: i18n.gettext('标准合同模板'),
  2: i18n.gettext('佣金策略合同模板'),
  3: i18nVue.t('Gattaran_contract20250806_cBZW_LivD' /** 非标准合同 */),
  21: i18n.gettext('信息变更协议'),
  31: i18n.gettext('追加门店协议'),
  32: i18n.gettext('追加门店协议v2.0'),
  40: i18nVue.t('Gattaran_Project1_qBWM_gsHb' /** 独家协议 */),
  41: i18nVue.t('Gattaran_B90_VNZU_PlRV' /** 佣金补贴协议 */),
  42: i18nVue.t('Gattaran_B90_VNZU_PlRV' /** 佣金补贴协议 */),
}

export const SIGN_COUNTRY_LIST = [
  {
    label: i18n.gettext('墨西哥'),
    value: 'MX',
  },
]
export const SIGN_PARTY_TYPE_LIST = [
  {
    label: i18n.gettext('普通商家'),
    value: 1,
  },
  {
    label: i18n.gettext('CKA'),
    value: 2,
  },
  {
    label: i18n.gettext('KA'),
    value: 3,
  },
]

export const SIGN_PARTY_TYPE_LIST_V2 = [
  {
    text: i18n.gettext('普通商家'),
    value: 1,
  },
  {
    text: i18n.gettext('CKA'),
    value: 2,
  },
  {
    text: i18n.gettext('KA'),
    value: 3,
  },
]

export const PHONE_PERFIX = {
  MX: '+52',
  BR: '+55',
  CR: '+506',
  CL: '+56',
  DO: '+1',
  CO: '+57',
  PE: '+51',
}

export const CARD_HOLDER_TYPE = [
  {
    label: i18nVue.t('FoodB_Show_ID_Card_BrxO' /** 身份证 */),
    value: 9,
  },
  {
    label: i18nVue.t('FoodB_Show_Aliens_Residence_creU' /** 外国人居留卡 */),
    value: 10,
  },
  {
    label: i18nVue.t('FoodD_payout_Company_Registration_zoVW' /** 公司注册号 */),
    value: 11,
  },
]

export const CARD_HOLDER_TYPE_MAP = {
  9: i18nVue.t('FoodB_Show_ID_Card_BrxO' /** 身份证 */),
  10: i18nVue.t('FoodB_Show_Aliens_Residence_creU' /** 外国人居留卡 */),
  11: i18nVue.t('FoodD_payout_Company_Registration_zoVW' /** 公司注册号 */),
}

export const CARD_HOLDER_TYPE_DO = [
  {
    text: i18nVue.t('FoodB_Launch_DR_ID_AnVk' /** DR-身份证 */),
    value: 16,
  },
  {
    text: i18nVue.t('FoodB_Launch_DR_Military_Rxvi' /** DR-军人证 */),
    value: 17,
  },
  {
    text: i18nVue.t('FoodB_Launch_DR_Foreigner_gXpW' /** DR-外国人证 */),
    value: 18,
  },
  {
    text: i18nVue.t('FoodB_Launch_DR_Temporary_BQFH' /** DR-临时居留证 */),
    value: 19,
  },
  {
    text: i18nVue.t('FoodB_Launch_DR_Passport_JChW' /** DR-护照 */),
    value: 20,
  },
]

export const CO_ACCOUNT_TYPE = [
  {
    text: i18nVue.t('FoodB_Show_Current_NJqK' /** '活期' **/),
    value: 1,
  },
  {
    text: i18nVue.t('FoodB_Show_Savings_uvSS' /** '储蓄' **/),
    value: 2,
  },
]

export const CL_ACCOUNT_TYPE = [
  {
    text: i18nVue.t('FoodB_Show_Current_NJqK' /** '活期' **/),
    value: 1,
  },
  {
    text: i18nVue.t('FoodB_Show_Savings_uvSS' /** '储蓄' **/),
    value: 2,
  },
  {
    text: i18nVue.t('FoodB_CL_Vista_Account_QcOm' /** Vista账户 **/),
    value: 3,
  },
]

export const PE_ACCOUNT_TYPE = [
  {
    text: i18nVue.t('FoodOpB_Translation_Cash_accounts_fSLJ' /** 现金账户 **/),
    value: 1,
  },
  {
    text: i18nVue.t('FoodOpB_Translation_General_accounts_NeVu' /** 一般账户 **/),
    value: 2,
  },
  {
    text: i18nVue.t('FoodOpB_Translation_Maestra_Accounts_ktyA' /** Maestra accounts **/),
    value: 4,
  },
]

export const TAX_TYPE = [
  {
    text: i18nVue.t('FoodOpB_CO_Not_applicable_WuPn' /** '不适用' **/),
    value: '1',
  },
  {
    text: i18nVue.t('FoodOpB_CO_Provisional_Tax_ZpCx' /** '临时缴税金额' **/),
    value: '2',
  },
  {
    text: i18nVue.t('FoodB_Show_Final_Tax_XQQi' /** '最终缴税金额' **/),
    value: '3',
  },
]

export const TAX_SOURCE_TYPE_MX = [
  {
    text: i18nVue.t(
      'FoodB_collection_625_System_iWnH' /** '625-通过技术平台获得收入的商业活动制度' **/,
    ),
    value: '625',
  },
]

export const SIGN_PARTY_TYPE_NORMAL_OPTIIN = {
  label: i18n.gettext('普通商家'),
  value: 1,
}

export const SIGN_PARTY_TYPE_CKA_OPTIIN = {
  label: i18n.gettext('CKA'),
  value: 2,
}

export const SIGN_PARTY_TYPE_KA_OPTIIN = {
  label: i18n.gettext('KA'),
  value: 3,
}

export const SIGN_PARTY_TYPE_MAP = {
  1: i18n.gettext('普通商家'),
  2: i18n.gettext('CKA'),
  3: i18n.gettext('KA'),
}

export const SIGN_PARTY_TYPE_MAP_NAME = {
  1: 'NORMAL',
  2: 'CKA',
  3: 'KA',
}

export const SIGN_DELIVERY_TYPE_LIST = [
  {
    label: i18n.gettext('支持'),
    value: 1,
  },
  {
    label: i18n.gettext('不支持'),
    value: 2,
  },
]

export const SIGN_DELIVERY_TYPE_MAP = {
  1: i18n.gettext('支持'),
  0: i18n.gettext('不支持'),
}

export const AUTO_SWITCH_MAP = {
  0: i18n.gettext('手动上下线'),
  1: i18n.gettext('自动下线'),
  2: i18n.gettext('自动上线'),
  3: i18n.gettext('自动上下线'),
}

export const SIGN_PARTYA_TITLE_MAP = {
  1: i18n.gettext('合法代表'),
  2: i18n.gettext('董事'),
  3: i18n.gettext('授权人'),
  4: i18n.gettext('其他'),
}

export const SIGN_PARTYA_TITLE_LIST = [
  {
    value: 1,
    text: i18n.gettext('合法代表'),
  },
  {
    value: 2,
    text: i18n.gettext('董事'),
  },
  {
    value: 3,
    text: i18n.gettext('授权人'),
  },
  {
    value: 4,
    text: i18n.gettext('其他'),
  },
]

export const SIGN_LEGAL_TYPE_LIST_CL = [
  {
    value: 9,
    text: i18nVue.t('FoodB_Show_ID_Card_BrxO' /** 身份证 */),
  },
  {
    value: 13,
    text: i18n.gettext('护照'),
  },
]

export const SIGN_LEGAL_TYPE_LIST_NEW = {
  1: i18n.gettext('新版'),
  2: i18n.gettext('老版无Curp'),
  3: i18n.gettext('老版有Curp'),
  40: i18nVue.t('FoodB_improvement_NRct_GSoW'), // 护照
  41: i18nVue.t('FoodB_improvement_sBdi_DQvl'), // 'FM3',
  42: i18nVue.t('FoodB_improvement_iyXo_BbDz'), // 'FM2',
}

export const SIGN_LEGAL_TYPE_LIST = [
  {
    value: 9,
    text: i18nVue.t('FoodB_Show_ID_Card_BrxO' /** 身份证 */),
  },
  {
    value: 13,
    text: i18n.gettext('护照'),
  },
  {
    value: 10,
    text: i18nVue.t('FoodB_Show_Aliens_Residence_creU' /** 外国人居留卡 */),
  },
  {
    value: 12,
    text: i18nVue.t('FoodB_Show_Foreign_DIMEX_LKxF' /** 外国人DIMEX */),
  },
]

export const SIGN_LEGAL_TYPE_LIST_MX = [
  {
    value: 1,
    text: i18n.gettext('新版'),
  },
  {
    value: 2,
    text: i18n.gettext('老版无Curp'),
  },
  {
    value: 3,
    text: i18n.gettext('老版有Curp'),
  },
]

export const SIGN_LEGAL_TYPE_LIST_CO = [
  {
    value: 9,
    text: i18nVue.t('FoodB_Show_ID_Card_BrxO' /** 身份证 */),
  },
  {
    value: 10,
    text: i18nVue.t('FoodB_Show_Aliens_Residence_creU' /** 外国人居留卡 */),
  },
  {
    value: 14,
    text: i18nVue.t('FoodB_Show_Special_residence_ezfV' /** 外国人特殊居留证 */),
  },
]
export const SIGN_LEGAL_TYPE_LIST_DO = [
  {
    text: i18nVue.t('FoodB_Launch_DR_ID_AnVk' /** DR-身份证 */),
    value: 16,
  },
  {
    text: i18nVue.t('FoodB_Launch_DR_Military_Rxvi' /** DR-军人证 */),
    value: 17,
  },
  {
    text: i18nVue.t('FoodB_Launch_DR_Foreigner_gXpW' /** DR-外国人证 */),
    value: 18,
  },
  {
    text: i18nVue.t('FoodB_Launch_DR_Temporary_BQFH' /** DR-临时居留证 */),
    value: 19,
  },
  {
    text: i18nVue.t('FoodB_Launch_DR_Passport_JChW' /** DR-护照 */),
    value: 20,
  },
]

export const SIGN_LEGAL_TYPE_LIST_PE = [
  {
    text: i18nVue.t('FoodB_Show_ID_Card_BrxO' /** 身份证 */),
    value: 9,
  },
  {
    text: i18n.gettext('护照'),
    value: 13,
  },
  {
    text: i18nVue.t('Gattaran_Translation_Alien_ID_IMja' /** 外国人身份证 */),
    value: 29,
  },
]

export const SIGN_AUTHORIZATION_TYPE_LIST = [
  {
    value: 1,
    text: i18n.gettext('签约授权书'),
  },
  {
    value: 2,
    label: i18n.gettext('打款授权书'),
  },
  {
    value: 3,
    label: i18n.gettext('品牌授权书'),
  },
]

export const SIGN_CONTRACT_TEMPLATE_TYPE_LIST = [
  {
    value: 1,
    label: i18n.gettext('标准合同模板'),
  },
]

export const SIGN_SHOP_STATUS_MAP = {
  0: i18n.gettext('信息未完善'),
  1: i18n.gettext('信息已完善'),
}
export const SIGN_SHOP_STATUS_TYPE_MAP = {
  0: 'warning',
  1: 'success',
}

export const SIGN_PACK_AUDIT_STATUS_MAP = {
  1: i18n.gettext('审核中'),
  2: i18n.gettext('审核失败'),
  3: i18n.gettext('审核完成'),
}
export const SIGN_PACK_AUDIT_STATUS_TYPE_MAP = {
  1: 'warning',
  2: 'danger',
  3: 'success',
}

export const SIGN_AUDIT_STATUS_MAP = {
  2: i18n.gettext('审核中'),
  3: i18n.gettext('审核失败'),
  4: i18n.gettext('审核完成'),
  5: i18n.gettext('审核通过'),
}

export const SIGI_DISABLED_STATUS_LIST = [2, 4, 5]

export const SIGN_AUDIT_STATUS_TYPE_MAP = {
  1: 'info',
  2: 'warning',
  3: 'danger',
  4: 'success',
  5: 'success',
}

export const SIGN_PACK_TO_TAB_MAP = {
  soda_restaurant: 'basic',
  soda_restaurant_license: 'qualification',
  soda_restaurant_contract: 'contract',
  soda_restaurant_legal: 'contract',
}

export const SIGN_CONTRACT_TYPE_LIST = [
  {
    value: 1,
    text: i18n.gettext('标准合同模板'),
  },
  {
    value: 2,
    text: i18n.gettext('佣金策略合同模板'),
  },
]

export const SIGN_CONTRACT_VERSION_MAP = {
  1: '1.0',
}

export const SIGN_CONTRACTOR_TYPE_MAP = {
  1: i18nVue.t('FoodB_Show_Companies_Limited_xsLB' /** 股份有限公司 */),
  2: i18nVue.t('FoodB_Show_Companies_Limited_hFAJ' /** 有限责任公司 */),
  3: i18n.gettext('个人'),
}

export const SIGN_CONTRACTOR_TYPE_LIST = [
  {
    value: 1,
    text: i18n.gettext('股份有限公司'),
  },
  {
    value: 2,
    text: i18n.gettext('有限责任公司'),
  },
  {
    value: 3,
    text: i18n.gettext('个人'),
  },
]

export const SIGN_CONTRACTOR_TYPE_LIST_BR = [
  {
    value: 1,
    text: i18n.gettext('股份有限公司'),
  },
  {
    value: 2,
    text: i18n.gettext('有限责任公司'),
  },
  {
    value: 3,
    text: i18n.gettext('个人'),
  },
  {
    value: 4,
    text: i18n.gettext('个人企业'),
  },
]

export const SIGN_CONTRACTOR_TYPE_LIST_CL = [
  {
    value: 7,
    text: i18nVue.t('FoodB_CL_Traditional_companies_cQhK' /** 传统公司 */),
  },
  {
    value: 6,
    text: i18nVue.t('FoodB_CL_Simple_company_JBRG' /** 简单公司 */),
  },
  {
    value: 3,
    text: i18nVue.t('FoodB_CL_Individuals_VUHt' /** 个人 */),
  },
]

// PE商户主体类型
export const SIGN_CONTRACTOR_TYPE_LIST_PE = [
  {
    value: 3,
    text: i18nVue.t('FoodOpB_Translation_Natural_persons_fVFa' /** 自然人 */),
  },
  {
    value: 8,
    text: i18nVue.t('FoodOpB_Translation_Legal_persons_RduO' /** 法人 */),
  },
]

export const SIGN_PACK_DRAFT_STATUS_MAP = {
  UNSAVED: 1,
  SAVED: 2,
}

export const PACK_NUM_1 = 'soda_restaurant'
export const PACK_NUM_2 = 'soda_restaurant_license'
export const PACK_NUM_3 = 'soda_restaurant_contract'
export const PACK_NUM_4 = 'soda_restaurant_legal'

export const PACK_NUM_1_KEYS = ['name', 'logo']
export const PACK_NUM_2_KEYS = ['licensePics']
export const PACK_NUM_3_KEYS = [
  'contractNo',
  'partyaName',
  'partyaEmail',
  'partyaContact',
  'partyaPhone',
  'accountHolder',
  'accountAddr',
  'accountCardno',
  'oneselfType',
  'platformType',
  'oneselfRate',
  'platformRate',
]
export const PACK_NUM_4_KEYS = ['legalName', 'legalType', 'legalId', 'legalPics', 'legalExtra']

export const CATEGORY_MAP = {
  1: ['basic'],
  2: ['qualification'],
  3: ['contract'],
  4: ['contractorOther', 'shopOther', 'other'],
}

// 启动费金额 梯度
export const STARTUP_MONEY_SELECT_LIST_CONFIG = [
  {
    text: '0',
    value: 0,
  },
  {
    text: '500',
    value: 50000,
  },
  {
    text: '1000',
    value: 100000,
  },
  {
    text: '1500',
    value: 150000,
  },
  {
    text: '2000',
    value: 200000,
  },
  {
    text: '2500',
    value: 250000,
  },
  {
    text: '3000',
    value: 300000,
  },
  {
    text: '3500',
    value: 350000,
  },
  {
    text: '4000',
    value: 400000,
  },
  {
    text: '4500',
    value: 450000,
  },
  {
    text: '5000',
    value: 500000,
  },
]

export const STARTUP_MONEY_SELECT_LIST_CONFIG_MX = generateNum(0, 5000, 500, true, true).map(
  item => {
    return {
      text: item + '',
      value: String(item * 100),
    }
  },
)

export const STARTUP_MONEY_SELECT_LIST_CONFIG_BR = generateNum(0, 700, 100, true, true).map(
  item => {
    return {
      text: item + '',
      value: String(item * 100),
    }
  },
)

export const STARTUP_MONEY_SELECT_LIST_CONFIG_CO = generateNum(0, 1150000, 115000, true, true).map(
  item => {
    return {
      text: item + '',
      value: item + '',
    }
  },
)

export const STARTUP_MONEY_SELECT_LIST_CONFIG_CL = generateNum(0, 200000, 20000, true, true).map(
  item => {
    return {
      text: item + '',
      value: String(item * 100),
    }
  },
)

export const STARTUP_MONEY_SELECT_LIST_CONFIG_PE = generateNum(0, 1000, 100, true, true).map(
  item => {
    return {
      text: item + '',
      value: String(item * 100),
    }
  },
)

// 设备信息： 是否需要pad
export const EQUIPMENT_INFO_PAD_SELECT_LIST = [
  {
    text: i18n.gettext('需要'),
    value: 1,
  },
  {
    text: i18n.gettext('不需要'),
    value: 0,
  },
]

// 默认合同版本 2.0
export const DEFAULT_CONTRACT_VERSOIN = '2.0'

// 哥斯达黎加新增证件类型

export const ID_TYPE_PERSONAL = [
  {
    text: i18nVue.t('FoodB_Show_ID_Card_BrxO'),
    value: 9,
  },
  {
    text: i18nVue.t('FoodB_Show_Special_Tax_Eidl'),
    value: 21,
  },
  {
    text: i18nVue.t('FoodB_Show_Foreign_DIMEX_LKxF'),
    value: 12,
  },
]

export const ID_TYPE_COMPANY = [
  {
    text: i18nVue.t('FoodB_Show_Company_Registration_VcVV'),
    value: 11,
  },
]

// 商户是否需要申报全国的税
export const TAX_VAT_PAYMENT_LIST = [
  {
    value: 1,
    text: i18nVue.t('FoodB_field_Needs_IbzB' /** 需要 */),
  },
  {
    value: 2,
    text: i18nVue.t('FoodB_field_No_need_hToz' /** 不需要 */),
  },
]

// 商户是否需要申报当地的税
export const LOCALE_TAX_VAT_PAYMENT_LIST = [
  {
    value: 1,
    text: i18nVue.t('FoodB_field_Needs_IbzB' /** 需要 */),
  },
  {
    value: 2,
    text: i18nVue.t('FoodB_field_No_need_hToz' /** 不需要 */),
  },
]

export const KP_CONTACTMODE = [
  {
    label: i18nVue.t('FoodB_2_Call_visit_NGFu' /** 电话 */),
    value: 1,
  },
  {
    label: i18nVue.t('FoodB_0_WhatsApp_dmMD' /** Whatsapp */),
    value: 2,
  },
  {
    label: i18nVue.t('FoodB_0_Mail_SUKZ' /** 邮件 */),
    value: 3,
  },
  {
    label: i18nVue.t('FoodB_2_Online_visit_OLuR' /** 线下 */),
    value: 4,
  },
  {
    label: i18nVue.t('FoodB_0_SMS_yOMB' /** 短信 */),
    value: 5,
  },
]
// 纳税类型（全国）
export const TAX_PAYMENT_METHOD = [
  {
    text: i18nVue.t('FoodOpB_CO_Not_applicable_WuPn' /** '不适用' **/),
    value: '1',
  },
  {
    text: i18nVue.t('FoodOpB_CO_Provisional_Tax_ZpCx' /** '临时缴税金额' **/),
    value: '2',
  },
  {
    text: i18nVue.t('FoodB_Show_Final_Tax_XQQi' /** '最终缴税金额' **/),
    value: '3',
  },
]

/**
 * 国家对应 姓名书写顺序配置
 * 不同国家 有的姓名书写是 姓在前 有的是名在前，accountFirstName 对应的是写在前边的字符 accountLastName 对应的是写在后边的字符
 * 主要应用在结算信息等财务相关
 * 不需要区分前后的无需使用改配置
 */
const FULL_NAME = {
  firstName: i18n.gettext('持卡人姓'),
  lastName: i18n.gettext('持卡人名'),
}
const REVERSE_FULL_NAME = {
  firstName: i18n.gettext('持卡人名'),
  lastName: i18n.gettext('持卡人姓'),
}

const COUNTRY_FULL_NAME_CONFIG = {
  MX: FULL_NAME,
  BR: FULL_NAME,
  JP: FULL_NAME,
  CO: REVERSE_FULL_NAME,
  CR: REVERSE_FULL_NAME,
  DO: REVERSE_FULL_NAME,
  CL: FULL_NAME,
  PE: REVERSE_FULL_NAME,
  AR: REVERSE_FULL_NAME,
}

export function getCountryFullNameConfig(country) {
  return COUNTRY_FULL_NAME_CONFIG[country] || REVERSE_FULL_NAME || {}
}

export const PICKING_PAY_MODE_DATA_LIST = [
  {
    label: i18nVue.t('Groceries_calculation_LoxD_wbPj' /** 预付卡 */),
    value: 1,
  },
  {
    label: i18nVue.t('Groceries_calculation_btkC_kGie' /** 二维码 */),
    value: 3,
  },
  {
    label: i18nVue.t('Groceries_calculation_UadY_RROs' /** 二维码可降级为预付卡 */),
    value: 2,
  },
  {
    label: i18nVue.t('Gattaran_202412_nVQh_JkKC' /** 无需平台进行线下支付 */),
    value: 0,
  },
]

export const SHOP_SUBSIDY_ACTIVE_OPTIONS = [
  {
    label: i18n.gettext('否'),
    value: 0,
  },
  {
    label: i18n.gettext('是'),
    value: 1,
  },
  {
    label: '/',
    value: 2,
  },
]

export const OFFLINEORDERVOLUMNl_LIST = [
  {
    label: '0-20',
    value: 1,
  },
  {
    label: '20-50',
    value: 2,
  },
  {
    label: '50-100',
    value: 3,
  },
  {
    label: '100+',
    value: 4,
  },
]

export const OFFLINEORDERVOLUMNl_LIST_MAP = {
  1: '0-20',
  2: '20-50',
  3: '50-100',
  4: '100+',
}

export const DARK_KITCHEN_LIST = {
  1: i18nVue.t('Gattaran_Project1_UAHJ_vNYg' /** 是 */),
  2: i18nVue.t('Gattaran_Project1_qUNd_LROh' /** 否 */),
}

export const BIZOPP_STATUS_ENUM = {
  /** 跟进中 */
  FOLLOW_UP: 1,
  /** 草稿中 */
  DRAFT: 2,
  /** 审批中 */
  APPROVAL: 3,
  /** 审批失败 */
  APPROVAL_FAILED: 4,
  /** 已签约 */
  SIGNED: 5,
  /** 无效 */
  INVALID: 6,
  /** 审批通过 */
  APPROVAL_PASSED: 8,
  /** 已核准 */
  APPROVED: 9,
  /** 已签章 */
  SEALED: 10,
}

export const SUBSIDY_SCENE_ENUM = [
  // 补贴场景
  {
    value: 0,
    label: i18nVue.t('Gattaran_Project1_ISPe_FApQ'), // 普通协议
  },
  {
    value: 1,
    label: i18nVue.t('Gattaran_Project1_qBWM_gsHb'), // 独家协议
  },
  {
    value: 2,
    label: i18nVue.t('Gattaran_Tag_zvmg_JRLw'), // 破独协议
  },
  {
    value: 3,
    label: i18nVue.t('Gattaran_Tag_RfaA_zLYz'), // 防独协议
  },
]

export const SUBSIDY_SCENE_MAP = {
  0: i18nVue.t('Gattaran_Project1_ISPe_FApQ'), // 普通协议
  1: i18nVue.t('Gattaran_Project1_qBWM_gsHb'), // 独家协议
  2: i18nVue.t('Gattaran_Tag_zvmg_JRLw'), // 破独协议
  3: i18nVue.t('Gattaran_Tag_RfaA_zLYz'), // 防独协议
}
export const CONTROL_PLATFORM_LIST = [
  {
    label: 'Black',
    value: 1,
  },
  {
    label: 'Pink',
    value: 2,
  },
  {
    label: 'Yellow',
    value: 3,
  },
]
